import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  @Input() type: 'standard' | 'small' | 'add' = 'standard';
  @Input() fill: 'solid' | 'outline' | 'clear' = 'solid';
  @Input() color: 'orange' | 'coralverydark' | 'darkgrey' | 'white' | 'grey' | 'red' | 'dark' | 'green' = 'orange';
  @Input() expand: 'block' | 'full' | '' = 'full';
  @Input() label: string;
  @Input() id: string;
  @Input() icon: {name: string, color?: string, slot?: string};
  @Input() route: string[];
  @Input() disabled = false;
  @Input() hideSpinner = true;
  @Input() customStyle: any = {};
  @Output() clickEvent = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {}

  onClick() {
    this.clickEvent.emit(true);
  }
}
